<template>
  <div class="mobile-app">
    <div class="container">
      <h1 class="page-title">{{ $t('mobileApp.title') }}</h1>
      
      <div class="placeholder-content">
        <el-empty :description="$t('mobileApp.redirecting')">
          <template #image>
            <img src="@/assets/images/mobile-app.svg" :alt="$t('mobileApp.imageAlt')" class="mobile-app-image">
          </template>
          <el-button type="primary" @click="openMobileApp">{{ $t('mobileApp.visitButton') }}</el-button>
        </el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'MobileAppView',
  setup() {
    const mobileAppLink = 'https://mobile.tqsms.xyz'
    
    const openMobileApp = () => {
      window.open(mobileAppLink, '_blank', 'noopener,noreferrer')
    }
    
    onMounted(() => {
      // 自动跳转到移动端网站
      openMobileApp()
    })
    
    return {
      openMobileApp
    }
  }
}
</script>

<style scoped>
.mobile-app {
  padding: 40px 0;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #333;
}

.placeholder-content {
  margin: 100px 0;
  display: flex;
  justify-content: center;
}

.mobile-app-image {
  width: 200px;
  height: auto;
}
</style> 